import { render, staticRenderFns } from "./excludedKeywords.vue?vue&type=template&id=89952894&scoped=true&"
import script from "./excludedKeywords.vue?vue&type=script&lang=js&"
export * from "./excludedKeywords.vue?vue&type=script&lang=js&"
import style0 from "./excludedKeywords.vue?vue&type=style&index=0&id=89952894&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89952894",
  null
  
)

export default component.exports